import React, { Component } from 'react'
import Link from 'gatsby-link'
import {AdvanceButton} from './advance-button'

import './slide.css'

class SlideAdvanceArea extends Component {

  constructor(props){
    super(props);
    this.state = {
      advanceButtonVisible : false,
    };

    this.showAdvanceButton = this.showAdvanceButton.bind(this);
    this.hideAdvanceButton = this.hideAdvanceButton.bind(this);
  }

  showAdvanceButton() {
    this.setState({advanceButtonVisible : true});
  }

  hideAdvanceButton() {
    this.setState({advanceButtonVisible : false});
  }

  render () {

    let offset = this.props.isLeftAdvance ? "left-offset" : "right-offset";
    return (
      <div onMouseEnter={this.showAdvanceButton} onMouseLeave={this.hideAdvanceButton}>
        <Link to = {this.props.href} className = "advance-area">
        </Link>
        <div className = {"middle " + offset}>
          <AdvanceButton
            pointsLeft = {this.props.isLeftAdvance ? true : false}
            onClick = {this.props.onAdvance}
            isVisible = {this.state.advanceButtonVisible}>
            </AdvanceButton>
        </div>
      </div>
    );
  }
}


export default {SlideAdvanceArea}



// WEBPACK FOOTER //
// ./src/components/Slide/slide-advance-area.js